import React, { useState, useEffect } from "react";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./SubMapping.module.css";
import { getFixedAssetSubmappingCurrency } from "../../../../Bookclosure/Services/ApiHandler";

export default function Currency({ FixedAssetID, onMappingChange }) {
  const [fields, setFields] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getFixedAssetSubmappingCurrency(FixedAssetID);

       const fieldsData = res?.data?.fields || [];
        const labels = res?.data?.labelList || [];

        const data = labels.map((label) => ({
          key: label,
          values: fieldsData
        }));
        setFields(data);

        const initialState = {};
        data.forEach((item) => {
          initialState[item.key] = "";
        });
        setSelectedValues(initialState);

      } catch (err) {
        console.error("Currency API error:", err);
      }
    };

    fetchData();
  }, [FixedAssetID]);

  const handleChange = (key, value) => {
    const updated = { ...selectedValues, [key]: value };
    setSelectedValues(updated);

    if (onMappingChange) {
      const formatted = Object.keys(updated).map((k) => ({
        key: k,
        values: updated[k] ? [updated[k]] : []
      }));
      onMappingChange(formatted);
    }
  };

  return (
    <div className={styles.formGroupGrid}>
      {fields.map((field) => (
       <CustomDropdown
          key={field.key}
          label={field.key}
          value={selectedValues[field.key] || ""}
          onChange={(value) => handleChange(field.key, value)}
          options={field.values || []}
          placeholder="Map Column"
          height="35px"
        />
      ))}
    </div>
  );
}